exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".learning-tree-container {\r\n  padding: 24px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.learning-tree-container__header {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.learning-tree-container__title {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  margin: 0 0 8px 0;\r\n  color: #333;\r\n}\r\n\r\n.learning-tree-container__subtitle {\r\n  font-size: 16px;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n.learning-tree-container__error {\r\n  text-align: center;\r\n  padding: 32px;\r\n  color: #d32f2f;\r\n  background: #ffebee;\r\n  border-radius: 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/learning-tree/learning-tree-container.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/user/learning-tree/learning-tree-container.component.css
// module chunks = main